<template>
  <div>
    <div ref="header" :class="[dataAnalysis&&'wire_head','head','noprint']"
      :style="{'margin-left':marginLeft}">
      <!-- 左侧 logo & title -->
      <div class="left">
        <div class="title">
          <img class="logo" :src="dataAnalysis?commonLogo:headerLogo" alt="logo"
            v-if="!isDev && !isPr" />
          <span :class="[dataAnalysis&&'wire_txt','txt']">{{ title }}</span>
        </div>
      </div>

      <!-- 右侧 消息 & 功能介绍 & 用户信息 -->
      <div class="right">
        <div :class="[dataAnalysis&&'wire_txt','bell']" v-if="
          roles != 'schoolgrade' &&
          roles != 'schoolclazz' &&
          roles != 'schooldoctor' &&
          roles != 'superadmin'
        ">
          <el-badge class="badge" :is-dot="msgnum != 0">
            <i :class="msgnum > 0 ? 'el-icon-bell bell-shake' : 'el-icon-bell'"
              @click="openNotifyPage"></i>
          </el-badge>
        </div>

        <!-- 功能介绍&常见问题 -->
        <el-dropdown class="question-btn" trigger="click" placement="top" @command="handleCommand">
          <!-- <i class="el-icon-question"></i> -->
          <span :class="[dataAnalysis&&'wire_txt','icon','iconfont','icon-wenhao']"></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="isLoggedIn" command="introduce">功能介绍</el-dropdown-item>
            <el-dropdown-item command="updateLog">更新日志</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span class="vertical-line"></span>

        <!-- 用户信息 -->
        <div class="user-info">
          <div></div>
          <el-dropdown trigger="click" @command="handleCommand" @visible-change="visibleChange">
            <div :class="showUserIiem ? 'user-info-btn on' : 'user-info-btn'">
              <img :src="avatar" class="img" />
              <span class="info">
                <div :class="[dataAnalysis&&'wire_txt','hospital']">{{ school }}</div>
                <div class="name">{{ name }}</div>
              </span>
              <i aria-label="icon: caret-down" role="dropdown-icon"
                :class="[dataAnalysis&&'wire_txt','anticon','anticon-caret-down']"><svg
                  viewBox="0 0 1024 1024" class="" data-icon="caret-down" width="1em" height="1em"
                  fill="currentColor" aria-hidden="true" focusable="false">
                  <path
                    d="M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z">
                  </path>
                </svg></i>
            </div>
            <el-dropdown-menu slot="dropdown">
              <div class="user-info-item">
                <img :src="avatar" class="img" />
                <div class="info">
                  <div class="hospital">{{ school }}</div>
                  <div class="name">{{ name }}</div>
                </div>
              </div>
              <el-dropdown-item style="text-align: center" divided v-show="isDev"
                v-for="(item, index) in userList" :key="index" :command="item">{{ item.hospital }}
              </el-dropdown-item>
              <el-dropdown-item style="text-align: center" divided command="baseInfo">基本信息
              </el-dropdown-item>
              <el-dropdown-item style="text-align: center" divided command="logout">退出
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>

    <!-- 欢迎弹窗 -->
    <el-dialog width="800px" class="weldialog" :visible.sync="welcomeDialog"
      :close-on-click-modal="false">
      <div slot="title" class="dialog-title">
        <!-- 欢迎使用{{ welcome.area }}儿童青少年眼健康管理平台 -->
        {{isEdu? "欢迎使用学生健康监测预警系统" : "欢迎使用儿童青少年视力及常见病监测预警系统"}}
      </div>
      <div class="content_title">
        当前使用账号为{{ welcome.type }},其主要功能分别为：
      </div>
      <div class="dialoglist" v-for="(item, index) in jurisdiction" :key="index">
        <span>{{ index + 1 }}、{{ item.list }}：</span>
        {{ item.content }}
      </div>
      <div class="welfooter">
        <div>如有任何问题随时联系我们，咨询电话：{{ pubTel }}</div>
        <div>或扫描右侧二维码</div>
        <div class="welerwm">
          <img src="@/assets/jszh.png" alt />
          <div>技术咨询</div>
        </div>
      </div>
    </el-dialog>

    <!--90天未更改密码 -->
    <el-dialog width="600px" class="weldialog changePasswordDialog"
      :visible.sync="unChangePasswordDialog" :close-on-click-modal="false">
      <div class="content_title">
        您的密码已连续使用90天，建议您更换密码保证数据安全。
      </div>
      <el-button style="text-alain" type="primary" @click="changePassword"> 更改 </el-button>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie"
import { mapGetters } from "vuex"
import { getSchool } from "@/utils/auth"
import { getToken } from "@/utils/auth"
import { getUsernameWithoutPassword, demoAccountLogin } from "@/api/user"
import { mapState } from "vuex"
import Breadcrumb from "@/components/Breadcrumb"
export default {
  name: "Logo",
  computed: {
    isLoggedIn() {
      return !!getToken()
    },
    pubTel() {
      return ['0', '1', '0', '-', '5', '7', '2', '2', '1', '8', '6', '6'].join('')
    },
    marginLeft() {
      if (this.device === "mobile") {
        return '0px'
      } else {
        return this.sidebar.opened ? '210px' : '54px'
      }
    },
    ...mapState({
      is_first: (state) => state.user.is_first,
      is_password_old: (state) => state.user.is_password_old,
      breadcrumb: (state) => state.app.breadcrumb,
      dataAnalysis: (state) => state.app.dataAnalysis,
      device: (state) => state.app.device
    }),
    ...mapGetters(["logintime", "name", "avatar", "device", "roles", "msgnum", "sidebar", "currentPath"]),
    //展示页头部
    commonLogo() {
      if(this.isEdu){
        return require('@/assets/logoedu.png')
      }else {
        if (process.env.VUE_APP_MODE === 'fjsm') {
          return require('@/assets/logo_sm.png')
        } else {
          return require('@/assets/logo.png')
        }
      }
    },
    //数据分析页头部
    headerLogo() {
      if(this.isEdu){
        return require('@/assets/logoedu.png')
      }else {
        if (process.env.VUE_APP_MODE === 'fjsm') {
          return require('@/assets/header_logo_sm.png')
        } else {
          return require('@/assets/header_logo.png')
        }
      }
    }
  },
  watch: {
    marginLeft(newValue, oldValue) {
      const header = this.$refs.header
      if (newValue !== oldValue) {
        header.style.transition = 'margin-left 0.28s'
      }
    }
  },
  components: {
    Breadcrumb
  },
  data() {
    return {
      titleFirst: "学生健康监测预警系统【体检/传染病】",
      isPr: process.env.VUE_APP_MODE === 'pr',
      isDev:
        process.env.BASE_URL == "/wxaward/dev/",
        //|| process.env.BASE_URL == "/wxaward/ansdev/", //原演示环境
      isTest: process.env.BASE_URL == "/wxaward/demo/", //测试环境
      school: "",
      timer: "",
      welcomeDialog: true,
      unChangePasswordDialog: false,
      welcome: {
        area: "全国",
        type: "管理机构",
      },
      jurisdiction: [],
      title: "",
      showUserIiem: false,
      userList: [
        {
          hospital: "aaaa",
        },
        {
          hospital: "bbbb",
        },
      ],
      isEdu: sessionStorage.getItem('login-from') == 'loginedu'
    }
  },
  methods: {
    // 跳转更改密码界面
    changePassword() {
      this.$router.push("/setting?changepassword=1")
      this.unChangePasswordDialog = false
    },
    // 获取用户列表
    getUserList() {
      this.userList = []
      getUsernameWithoutPassword().then((res) => {
        if (res.error == -1) {
          this.userList = res.data
        }
      })
    },
    // 自动登录
    async autoLogin(data) {
      await this.$store.dispatch("user/logout")
      this.$router.push(`/login`)
      setTimeout(() => {
        demoAccountLogin({ id: data.id }).then((res) => {
          if (res.error == -1) {
            // 使用TOKEN直接登录
            this.$store
              .dispatch("user/loginByToken", res.data.token)
              .then(() => {
                this.$message({
                  message: "切换登录成功",
                  type: "success",
                })
                this.$router.push({ path: "/setting" })
              })
          }
        })
      }, 50)
    },
    //用户信息点击下拉
    visibleChange(e) {
      this.showUserIiem = e
    },
    //根据角色显示不同的权限页面
    async getjurisdiction() {
      const hasRole = Array.isArray(this.roles)
        ? this.roles.length > 0
        : Boolean(this.roles)
      if (!hasRole) {
        return
      }
      try {
  const { getJurisdictionByRole } = await import("@/utils/jurisdictionConfig")
  const config = await getJurisdictionByRole(this.roles)
        if (config) {
          this.welcome.type = config.type
          this.jurisdiction = config.items
        } else {
          this.jurisdiction = []
        }
      } catch (error) {
        // lazy chunk failed to load; degrade gracefully
        console.warn("Failed to load jurisdiction config", error)
        this.jurisdiction = []
      }
    },
    //绑定下拉菜单的命令事件
    handleCommand(command) {
      //打开功能介绍
      if (command == "introduce") {
        this.$router.push("/introduce")
      }
      // 打开更新日志
      if (command === "updateLog") {
        this.$router.push("/updateLog")
      }
      //退出
      if (command == "logout") {
        this.logout()
      }
      //退出
      if (command == "baseInfo") {
        this.$router.push("/setting")
      }
      //自动登录
      if (command.hospital) {
        this.autoLogin(command)
      }
    },
    //退出
    async logout() {
      await this.$store.dispatch("user/logout")
      if (sessionStorage.getItem('login-from') == 'quicklogin') {
        this.$router.push(`/quicklogin`)
      }else if(sessionStorage.getItem('login-from') == 'loginedu'){
        this.$router.push(`/loginedu`)
      } else {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
      Cookies.remove("first_sign")
      localStorage.setItem("tab", "")
      location.reload()
    },
    //更新消息数量
    updateMsgNumber() {
      this.$store.dispatch("user/updateMsgNumber")
    },
    //更新消息数量
    updateCustomerNumber() {
      this.$store.dispatch("user/updateCustomerNumber")
    },
    //打开消息页面
    openNotifyPage() {
      if (this.roles == "screen") {
        this.$router.push("/screen/notify")
      } else if (this.roles == "schooladmin") {
        this.$router.push("/school/notify")
      } else {
        this.$router.push("/gov/notify")
      }
    },
    //设置标题
    setTitle() {
      if (this.roles[0] == "superadmin"||this.roles[0] == "superadmin_03") {
        let adminName = process.env.VUE_APP_MODE === 'pr' ? '(主管单位：普瑞集团)' : '（主管单位：中国疾病预防控制中心）'
        this.title = this.isDev
          ? process.env.VUE_APP_TITLE
          : process.env.VUE_APP_TITLE + adminName
      } else if (
        this.roles[0] == "province" ||
        this.roles[0] == "province_03"
      ) {
        this.title =
          process.env.VUE_APP_TITLE + "（省疾控中心/教育局端：" + this.school + "）"
      } else if (
        this.roles[0] == "city" ||
        this.roles[0] == "city_03"
      ) {
        this.title =
          process.env.VUE_APP_TITLE + "（市疾控中心/教育局端：" + this.school + "）"
      } else if (
        this.roles[0] == "district" ||
        this.roles[0] == "district_03"
      ) {
        this.title =
          process.env.VUE_APP_TITLE + "（区县疾控中心/教育局端：" + this.school + "）"
      } else if (this.roles[0] == "screen" || this.roles[0] == "screen_03") {
        this.title =
          process.env.VUE_APP_TITLE + "（医疗机构名称：" + this.school + "）"
      } else if (
        this.roles[0] == "schooladmin" ||
        this.roles[0] == "schoolclazz" ||
        this.roles[0] == "schoolgrade" ||
        this.roles[0] == "schooldoctor"
      ) {
        this.title =
          process.env.VUE_APP_TITLE + "（学校：" + this.school + "）"
      }
    },
    //设置标题 教育体系
    setTitleEdu() {
      if (this.roles[0] == "superadmin"||this.roles[0] == "superadmin_03") {
        let adminName = '（主管单位：教育部）'
        this.title = this.isDev
          ? this.titleFirst
          : this.titleFirst + adminName
      } else if (
        this.roles[0] == "province" ||
        this.roles[0] == "province_03"
      ) {
        this.title =
          this.titleFirst + "（主管单位：" + this.school + "）"
      } else if (
        this.roles[0] == "city" ||
        this.roles[0] == "city_03"
      ) {
        this.title =
          this.titleFirst + "（主管单位：" + this.school + "）"
      } else if (
        this.roles[0] == "district" ||
        this.roles[0] == "district_03"
      ) {
        this.title =
          this.titleFirst + "（主管单位：" + this.school + "）"
      } else if (this.roles[0] == "screen" || this.roles[0] == "screen_03") {
        this.title =
          this.titleFirst + "（医疗机构名称：" + this.school + "）"
      } else if (
        this.roles[0] == "schooladmin" ||
        this.roles[0] == "schoolclazz" ||
        this.roles[0] == "schoolgrade" ||
        this.roles[0] == "schooldoctor"
      ) {
        this.title =
          this.titleFirst + "（学校：" + this.school + "）"
      }
    },
  },
  created() {
    this.school = getSchool()
    this.updateMsgNumber()
    this.updateCustomerNumber()
    // only load jurisdiction after we have a token (i.e. logged in)
    if (getToken()) {
      this.getjurisdiction()
    }
    if(this.isEdu){
      this.setTitleEdu()
    }else {
      this.setTitle()
    }
    
    this.getUserList()

    if (this.roles[0]=="superadmin_03") {
      this.welcomeDialog=false
    }
    if (
      this.is_first ||
      this.$route.path == "/gov/aera/city" ||
      Cookies.get("first_sign") == 1
    ) {
      this.welcomeDialog = false
    }
    if (this.is_first && this.is_password_old == 1) {
      this.unChangePasswordDialog = true
    }
    Cookies.set("first_sign", 1)
  },
};
</script>

<style lang="scss" scoped>
.changePasswordDialog {
  text-align: center;

  /deep/.el-dialog__body {
    padding: 5px 50px 40px !important;
  }
}

// 数据分析显示
.wire_head {
  background-color: #1e2949 !important;
  box-shadow: 0px 4px 10px 0px rgba(18, 27, 52, 0.6) !important;
}

.wire_txt {
  color: #fff !important;
}

.head {
  background-color: #fff;
  height: 60px;
  line-height: 60px;
  display: flex;
  position: relative;
  z-index: 11;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);

  .left {
    width: 60%;
    height: 60px;
    line-height: 60px;
    overflow: hidden;

    .title {
      padding-left: 15px;

      .logo {
        width: 40px;
        vertical-align: middle;
        margin-left: 10px;
        margin-right: 10px;
      }

      .txt {
        font-size: 18px;
        color: #1e2949;
        font-weight: bold;
      }
    }
  }

  .right {
    width: 40%;
    text-align: right;

    .bell {
      display: inline-block;
      vertical-align: middle;
      line-height: 1;
      padding-right: 16px;
      color: #1e2949;

      i {
        font-size: 20px;
      }

      /deep/ .el-badge__content {
        font-size: 10px;
        border: 0;
      }

      .el-icon-bell {
        cursor: pointer;
      }
    }

    .vertical-line {
      display: inline-block;
      width: 1px;
      height: 32px;
      vertical-align: middle;
      background-color: #e9f4fe;
      margin: 0 16px;
    }

    .question-btn {
      height: 52px;

      .icon-wenhao {
        color: #1e2949;
        font-size: 20px;
        font-weight: bold;
        vertical-align: middle;
        cursor: pointer;
      }
    }

    .user-info {
      position: relative;
      z-index: 9999;
      display: inline-block;
      vertical-align: middle;
      height: 40px;

      .user-info-btn {
        line-height: 20px;
        // display: flex;
        cursor: pointer;

        .img {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
        }

        .info {
          text-align: left;
          margin-left: 10px;
          // width: 150px;
          max-width: 200px;

          display: inline-block;

          .hospital {
            color: #1e2949;
            font-weight: bold;
            max-width: 200px;
            height: 20;
            white-space: nowrap;
            /*超出的空白区域不换行*/
            overflow: hidden;
            /*超出隐藏*/
            text-overflow: ellipsis;
            /*文本超出显示省略号*/
          }

          .name {
            background-color: #e9f4fe;
            font-size: 12px;
            display: inline-block;
            border-radius: 3px;
            line-height: 14px;
            padding: 0 3px;
          }
        }

        .anticon-caret-down {
          margin: 0 15px;
          cursor: pointer;
          vertical-align: middle;
          font-size: 14px;
          color: #1e2949;
          transform: rotate(0deg);
          transition: transform 0.3s ease-in-out;
          display: inline-block;
          font-style: normal;
          line-height: 0;
          text-align: center;
          text-transform: none;
          vertical-align: 10px;
          text-rendering: optimizeLegibility;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }
      }

      .user-info-btn.on {
        .anticon-caret-down {
          transform: rotate(180deg) !important;
        }
      }
    }
  }
}

.user-info-item {
  text-align: center;
  width: 220px;
  font-size: 14px;
  line-height: 20px;

  .img {
    width: 58px;
    height: 58px;
    object-fit: cover;
    border-radius: 50%;
    margin-top: 10px;
  }

  .info {
    line-height: 20px;
    padding: 10px 0;

    .name {
      color: #666;
    }
  }
}

/*
 *  This animation shake a bell.
 *  The percents are separated to add a "delay" between cycles
 *
 *  name: bell-shake
 */

@-webkit-keyframes bell-shake {
  1% {
    -webkit-transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  2% {
    -webkit-transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  3% {
    -webkit-transform: rotateZ(20deg);
    transform-origin: 50% 0%;
  }

  4% {
    -webkit-transform: rotateZ(-20deg);
    transform-origin: 50% 0%;
  }

  5% {
    -webkit-transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  6% {
    -webkit-transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  7% {
    -webkit-transform: rotateZ(0);
    transform-origin: 50% 0%;
  }

  100% {
    -webkit-transform: rotateZ(0);
    transform-origin: 50% 0%;
  }
}

@-moz-keyframes bell-shake {
  1% {
    -moz-transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  2% {
    -moz-transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  3% {
    -moz-transform: rotateZ(20deg);
    transform-origin: 50% 0%;
  }

  4% {
    -moz-transform: rotateZ(-20deg);
    transform-origin: 50% 0%;
  }

  5% {
    -moz-transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  6% {
    -moz-transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  7% {
    -moz-transform: rotateZ(0);
    transform-origin: 50% 0%;
  }

  100% {
    -moz-transform: rotateZ(0);
    transform-origin: 50% 0%;
  }
}

@keyframes bell-shake {
  1% {
    transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  2% {
    transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  3% {
    transform: rotateZ(20deg);
    transform-origin: 50% 0%;
  }

  4% {
    transform: rotateZ(-20deg);
    transform-origin: 50% 0%;
  }

  5% {
    transform: rotateZ(15deg);
    transform-origin: 50% 0%;
  }

  6% {
    transform: rotateZ(-15deg);
    transform-origin: 50% 0%;
  }

  7% {
    transform: rotateZ(0);
    transform-origin: 50% 0%;
  }

  100% {
    transform: rotateZ(0);
    transform-origin: 50% 0%;
  }
}

.bell-shake--hover:hover,
.bell-shake--hover:focus,
.bell-shake {
  -webkit-animation: bell-shake 3s ease infinite;
  -moz-animation: bell-shake 3s ease infinite;
  animation: bell-shake 3s ease infinite;
}

.bell-shake-delay {
  -webkit-animation: bell-shake 3s ease 2s infinite;
  -moz-animation: bell-shake 3s ease 2s infinite;
  animation: bell-shake 3s ease 2s infinite;
}

.weldialog {
  /deep/.el-icon-close:before {
    font-size: 36px;
  }

  .dialog-title {
    font-size: 24px;
    text-align: center;
    font-weight: bold;
    line-height: 42px;
  }

  /deep/.el-dialog__body {
    padding: 5px 50px 60px;

    .content_title {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 10px;
    }

    .dialoglist {
      font-size: 16px;
      line-height: 27px;

      span {
        font-weight: bold;
      }
    }

    .welfooter {
      font-size: 16px;
      line-height: 34px;
      padding-top: 16px;
      position: relative;

      .welerwm {
        position: absolute;
        right: 0;
        line-height: 16px;
        top: 0;
        text-align: center;

        img {
          width: 100px;
        }
      }
    }
  }
}
</style>
